import { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { RouterStatePopup } from 'APP/router/constants';
import useGetState from 'APP/router/hooks/useGetState';
import Entities from 'STORE';

export default () => {
  const sticker = useGetState(RouterStatePopup.sticker);
  const navigate = useNavigate();
  const location = useLocation();

  const onClose = useCallback(() => {
    navigate(location.pathname + location.search, { replace: true, state: null });
  }, [navigate, location.pathname, location.search]);

  useEffect(() => {
    window.addEventListener('mouseup', onClose);
    return () => {
      window.removeEventListener('mouseup', onClose);
    };
  }, [onClose]);

  return {
    onClose,
    sticker,
    displayUILayer: Entities.App.uiLayer,
  };
};
